export const AUTO_ACTIVATION_REASON_CODES = [
  'clear_single_consented',
  'clear_multi_consented',
  'hash_confirmed',
  'typesense_high_confidence',
] as const;

export type AutoActivationReasonCode =
  (typeof AUTO_ACTIVATION_REASON_CODES)[number];

export const AUTO_ACTIVATION_SOURCES = [
  'global',
  'per_number',
  'hash_confirmed',
  'typesense',
] as const;

export type AutoActivationSource = (typeof AUTO_ACTIVATION_SOURCES)[number];

export const PHONE_STANDING_CONSENT_GRANT_SOURCES = [
  'manual_accept_checkbox',
  'global_toggle_implicit',
  'admin',
] as const;

export type PhoneStandingConsentGrantSource =
  (typeof PHONE_STANDING_CONSENT_GRANT_SOURCES)[number];

export const AUTO_ACTIVATION_AUDIT_VERSION = 1 as const;
